/* lt-kit-gifts.js (23-09-2026, opdracht Thomas)
   Gratis Precisie schaartje + wimperborsteltje bij de Premium Starter Kit (fast-lashes-starter-kit-1)
   en de Basic Starter Kit (basic-starter-starter-kit).
   De configurator (starterkit-lp) legt zijn cadeaus zelf in de mand; de gewone Premium-PDP, collectie-knoppen
   en Kaching-upsells deden dat niet. Dit script houdt de mand in de pas: per kit 1x elk cadeau
   (de EUR 0,00-producten uit create_gift_products.py), gemarkeerd met _lt_kit_cadeau zodat alleen onze
   eigen regels worden bijgesteld of weggehaald. Configurator-cadeaus (eigenschap "Starterkit") blijven onaangeroerd.
   07-10-2026 (opdracht Thomas): ook de 5 Press-on Lashes Kits en (later die dag) de 5 losse press-on sets: per bestelling 1x gratis Lashthing Remover
   (de Non-sticky Tweezer komt via het Kaching-cadeau van de kitdeal) (cadeau-presson-tweezer / cadeau-presson-remover, script
   VPS /root/presson_doos_v2/gift_products.py).
   03-11-2026 (Thomas, Black November): de betaalde tweezer (EUR 4,95) uit het press-on koopblok (snippets/presson-bf-kiezer.liquid)
   blijft max 1 per bestelling en verdwijnt als er geen press-on lashes meer in de mand zitten (regel per: "max1"). */
(function () {
  "use strict";
  if (window.__ltKitGifts) return;
  window.__ltKitGifts = true;

  // per: "kit" = 1 per kit in de mand, "order" = 1 per bestelling zodra er een kit in zit
  var RULES = [
    { kits: [15548125675864, 15569076126040],          // Premium Starter Kit, Basic Starter Kit (sinds 23-09)
      label: "Starter Kit",
      gifts: [{ id: 58472252277080, per: "kit" },      // cadeau-precisie-schaartje
              { id: 58472252473688, per: "kit" }] },   // cadeau-wimper-brush
    { kits: [16046907130200, 16058508640600, 16058508706136, 16058508902744, 16058509066584, // Press-on Lashes Kit Noa/Mia/Molly/Evi/Bella
             16069516591448, 16069516624216, 16069516656984, 16069516689752, 16069516722520], // losse Press-on Lashes Noa/Mia/Molly/Evi/Bella (07-10, Thomas: overal 1 remover)
      label: "Press-on Lashes Kit",
      // De tweezer NIET hier: die geeft Kaching al als gratis cadeau vanaf "1 Stuk" (dubbel voorkomen, 07-10).
      gifts: [{ id: 58681391448408, per: "order" },     // cadeau-presson-remover
              { id: 59020686197080, per: "max1", alle: true }] } // 03-11 (BF26): betaalde Non-sticky Tweezer EUR 4,95 (presson-tweezer-erbij): nooit toevoegen, max 1, weg zonder press-on lashes
  ];
  var TAG = "_lt_kit_cadeau";
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  var busy = false, again = false, timer = 0, runs = 0, windowStart = 0;

  function post(url, body) {
    return origFetch.call(window, url, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; });
  }

  function refreshUi() {
    try { if (window.kachingCartApi && window.kachingCartApi.refreshCart) window.kachingCartApi.refreshCart(); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}
    if (window.PUB_SUB_EVENTS && typeof window.publish === "function") {
      try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "lt-kit-gifts" }); } catch (e) {}
    }
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    origFetch.call(window, "/cart.js", { cache: "no-store", credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return false;
        var mine = {};
        cart.items.forEach(function (it) {
          if (it.properties && it.properties[TAG]) (mine[it.variant_id] = mine[it.variant_id] || []).push(it);
        });
        var add = [], updates = {}, changed = false;
        RULES.forEach(function (rule) {
          var kits = 0;
          cart.items.forEach(function (it) { if (rule.kits.indexOf(it.product_id) > -1) kits += it.quantity; });
          rule.gifts.forEach(function (gift) {
            var lines = gift.alle ? cart.items.filter(function (it) { return it.variant_id === gift.id; }) : (mine[gift.id] || []), have = 0;
            lines.forEach(function (l) { have += l.quantity; });
            var want = gift.per === "order" ? (kits > 0 ? 1 : 0) : gift.per === "max1" ? (kits > 0 ? Math.min(have, 1) : 0) : kits;
            if (have === want) return;
            if (gift.per === "max1" && !lines.length) return;
            changed = true;
            if (!lines.length) { add.push({ id: gift.id, quantity: want, properties: (function () { var p = {}; p[TAG] = rule.label; return p; })() }); return; }
            updates[lines[0].key] = want;
            for (var i = 1; i < lines.length; i++) updates[lines[i].key] = 0;
          });
        });
        if (!changed) return false;
        var now = Date.now();                        // vangnet tegen een lus: max 6 wijzigingen per 10 s
        if (now - windowStart > 10000) { windowStart = now; runs = 0; }
        if (++runs > 6) return false;
        var steps = Promise.resolve();
        if (Object.keys(updates).length) steps = steps.then(function () { return post("/cart/update.js", { updates: updates }); });
        if (add.length) steps = steps.then(function () { return post("/cart/add.js", { items: add }); });
        return steps.then(function () { return true; });
      })
      .then(function (didChange) { if (didChange) refreshUi(); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; plan(300); }
      });
  }

  function plan(ms) { clearTimeout(timer); timer = setTimeout(sync, ms || 250); }

  // Mand-wijzigingen via fetch (thema, Kaching-drawer) en XHR.
  window.fetch = function (input, init) {
    var p = origFetch.apply(this, arguments);
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (CART_RE.test(url)) p.then(function () { plan(); }, function () {});
    } catch (e) {}
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { if (CART_RE.test(String(url))) this.addEventListener("loadend", function () { plan(); }); } catch (e) {}
    return origOpen.apply(this, arguments);
  };
  if (window.PUB_SUB_EVENTS && typeof window.subscribe === "function") {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) { if (!ev || ev.source !== "lt-kit-gifts") plan(); }); } catch (e) {}
  }
  // Kaching-bundels gaan via de app-proxy buiten fetch om: na een klik op een knop nog een keer kijken.
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest("button, [type=submit], [name=add]")) { setTimeout(function () { plan(); }, 1500); }
  }, true);
  window.addEventListener("pageshow", function () { plan(400); });
  plan(400);
})();
